const initialState = {
    responseTagsList: [],
    responseTag: [],
    massiveTagResponse: [],
    massiveTagResponseError: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "TAGS_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseTagsList = []
            else
                newState.responseTagsList = action.value;

            newState.responseTag = []
            break;
        case "TAG_RESPONSE":
            newState.responseTag = action.value;
            break;
        case "MASSIVE_TAGS_RESPONSE":
            newState.massiveTagResponse = action.value;
            if (action.value.status === "ok") {
                newState.massiveTagResponseError = false;
            } else {
                newState.massiveTagResponseError = true;
            }
            break;
        default: 
            return newState;
    }

    return newState;
};

export default reducer;